import { render } from "./CloseLocation.vue?vue&type=template&id=45c67f4e&ts=true"
import script from "./CloseLocation.vue?vue&type=script&lang=ts"
export * from "./CloseLocation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__